const module = { name: 'Fandango/dateUtil', exports: {} }; const exports = module.exports;



import { Fandango_util as util } from 'require-global';



import { Fandango_queryUtil as Fandango_queryUtil_getParam } from 'require-core';

const { getParam } = Fandango_queryUtil_getParam;


const RegExes = {
    YYYY_MM_DD: /(\d{2,4}(?:%2F|%20| |-)\d{1,2}(?:%2F|%20| |-)\d{1,2})\b/i,
    DD_MM_YYYY: /(\d{1,2})(?:%2F|%20| |-)(\d{1,2})(?:%2F|%20| |-)(\d{2,4})\b/i,
    SEPARATOR: /%2f|%20| |-/gi,
}


const QueryParams = {
    DATE: 'date',
}
function zeroPad(day) {
    if (typeof day === 'string') {
        day = parseInt(day, 10);
    }
    return (day < 10 ? '0' : '') + day;
}
function whatsThisDateToMe(date, requestDate) {
    const toDate = util.toDate;
    date = toDate(date);
    const dateString = date.toString();
    const today = requestDate ? toDate(requestDate) : toDate();
    const tomorrow = toDate();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return {
        inPast: date < today,
        inFuture: date > today,
        isToday: dateString === today.toString(),
        isTomorrow: dateString === tomorrow.toString(),
    };
}
function getFormatedDate(value, opts) {
    opts = opts || {};
    const separator = opts.iso ? '/' : '-';
    let m = value.match(RegExes.YYYY_MM_DD);
    if (m && m.length > 1) {
        m = m[1].split(RegExes.SEPARATOR);
        return (m[0].length < 3 ? '20' : '') + m[0] + separator + zeroPad(m[1]) + separator + zeroPad(m[2]);
    }
    m = value.match(RegExes.DD_MM_YYYY);
    if (m && m.length > 3) {
        return m[3] + separator + zeroPad(m[1]) + separator + zeroPad(m[2]);
    }
    return null;
}
function dateFromQuery(paramName, searchParams, opts) {
    let value = getParam(QueryParams.DATE, searchParams);
    if (!value) {
        value = getParam(paramName, searchParams);
    }
    return !value ? null : getFormatedDate(value, opts);
}
function formatDateObject(date) {
    if (!date) {
        return '';
    }
    if (typeof date !== 'object') {
        date = util.toDate(date);
    }
    const monthNames = [
        'Jan', 'Feb', 'Mar',
        'Apr', 'May', 'Jun', 'Jul',
        'Aug', 'Sept', 'Oct',
        'Nov', 'Dec'
    ];
    const weekdays = [
        'Mon', 'Tue',
        'Wed', 'Thu',
        'Fri', 'Sat',
        'Sun'
    ];
    const day = date.getDate();
    const month = date.getMonth() + 1;
    return {
        dayNameShort: weekdays[date.getDay() - 1],
        monthNameShort: monthNames[month - 1],
        day,
        full: `${date.getFullYear()}-${zeroPad(month)}-${zeroPad(day)}`
    };
}
module.exports = {
    dateFromQuery,
    formatDateObject,
    whatsThisDateToMe,
};
export default module.exports;